import { Component, EventEmitter, Inject, Input, NgZone, OnInit, Optional, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';
import { OnChanges, SimpleChanges } from '@angular/core';
import config from 'config/default.json';
import { FormControl } from '@angular/forms';
declare const DocsAPI: any;
declare const Api: any;
@Component({
  selector: 'app-float-window',
  templateUrl: './float-window.component.html',
  styleUrls: ['./float-window.component.scss']
})

export class FloatWindowComponent implements OnInit {
  constructor(
    private apiService: ApiServiceModule,
    private sharedService: SharedService,
    private ngZone: NgZone,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef: MatDialogRef<FloatWindowComponent>
  ) {}
  @Input() externalDataContent: any;
  userInfos: { [x:string]: any } = new Map();
  platformInfos: { [x:string]: any } = new Map();
  projectInfos: { [x:string]: any } = new Map();
  pageOrigin:string = '';
  source:string = '';
  fileUrls: {[x: string]: any}[] = [];
  @Output() closeExternal = new EventEmitter<any>();
  @Output() callBackEvent = new EventEmitter<any>();
  switchControl = new FormControl();
  pdfData: { [x:string]: any } = new Map();
  showMode:string = '';
  docxFile:string = '';

  editConfig:any;
  toEdit:boolean = false;
  editor: any;

  ngOnInit(){
    if(this.data.action == 'show-content') this.setData(this.data);
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['externalDataContent']) {
      this.setData(this.externalDataContent);
    }
  }
  setData(data:any){
    if (data) {
      this.userInfos = data.user_infos || {};
      this.platformInfos = data.platform_infos || {};
      this.projectInfos = data.project_infos || {};
      this.pageOrigin = data.page_origin || '';
      this.source = data.source || '';
      this.showMode = data.show_mode || '';
      this.switchControl.setValue(this.showMode);
      this.fileUrls = data.file_urls || [];
      this.docxFile = data.docx_file || '';

      this.pdfData =  {contents: this.fileUrls, source: this.source, height: 550};
      if(this.fileUrls.length > 0) this.switchDocument();
    }
    
  }
  
  switchDocument(){
    this.showMode = this.switchControl.value
    
    if(this.showMode != 'pdf-show'){
      
      if(this.editor) {
        this.editor.destroyEditor();
      }
      if(this.editConfig){
        this.editConfig.editorConfig.mode = this.showMode == 'docx-edit'? 'edit': 'view';
        this.editor = new DocsAPI.DocEditor('editor-container', this.editConfig);
      }else this.loadConfig();
      
    }
  }
  loadConfig() {
    let data = {
      target: 'master',
      id_content: null,
      id_project: null,
      file_url: this.docxFile,
      user_infos: this.userInfos
    }; 
    this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/content/onlyoffice_conf', data, this.userInfos['access_token']).subscribe((response:any)=>{
      this.editConfig = response;
      console.log(response)
      this.editConfig.editorConfig.mode = this.showMode == 'docx-edit'? 'edit': 'view';
      this.editor = new DocsAPI.DocEditor('editor-container', this.editConfig);
    });
  }
  callBackEventEmiter(data:any){
    if (this.data.action == 'show-content') 
      this.dialogRef.close(data);
    else this.callBackEvent.emit(data);
  }
  closeWindow() {
    if (this.data.action == 'show-content') 
      this.dialogRef.close(false);
    else this.closeExternal.emit(false);
  }
  reloadWindow(){

  }
}
